import { BlockquoteCallout } from './blockquote-callout';
import { HighlightText } from './highlight-text';
import { BenefitChecklist } from './benefit-checklist';

type ContentBlock = {
  type: 'paragraph' | 'heading' | 'blockquote' | 'highlight' | 'benefit-list' | 'html';
  text?: string;
  html?: string;
  level?: number;
  items?: string[];
};

type Props = {
  blocks: ContentBlock[];
  background?: 'white' | 'light' | 'gradient';
  maxWidth?: 'narrow' | 'wide';
};

function renderBlock(block: ContentBlock, i: number) {
  switch (block.type) {
    case 'heading': {
      const Tag = block.level === 3 ? 'h3' : block.level === 1 ? 'h1' : 'h2';
      return <Tag key={i}>{block.text}</Tag>;
    }
    case 'paragraph':
      return <p key={i}>{block.text}</p>;
    case 'blockquote':
      return <BlockquoteCallout key={i}>{block.text}</BlockquoteCallout>;
    case 'highlight':
      return (
        <p key={i}>
          <HighlightText>{block.text}</HighlightText>
        </p>
      );
    case 'benefit-list':
      return <BenefitChecklist key={i} items={block.items || []} />;
    case 'html':
      return (
        <div
          key={i}
          class="content-section"
          dangerouslySetInnerHTML={{ __html: block.html || '' }}
        />
      );
    default:
      return undefined;
  }
}

export function NarrativeCopy({ blocks }: Props) {
  return <div class="content-section">{blocks.map((block, i) => renderBlock(block, i))}</div>;
}
